var _defs, _rect, _g, _polygon, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIconsTouchpadUpDown(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #202346;\n        stroke-miterlimit: 10;\n        stroke-width: .75px;\n      }\n\n      .cls-2 {\n        fill: #202346;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: #d3343f;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.49,
    y: 9.35,
    width: 35.66,
    height: 29.04,
    rx: 2,
    ry: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m28.15,19.48c1.47-1.47,1.47-3.85,0-5.32s-3.85-1.47-5.32,0c-.55.55-.89,1.22-1.03,1.93-.71.14-1.38.48-1.93,1.03-1.47,1.47-1.47,3.85,0,5.32s3.85,1.47,5.32,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m42.15,27.42l-3.65-3.65c-.81-.81-1.83-.83-2.44-.21l-.03.03c-.6.6-.61,1.57,0,2.17l-1.04-1.04c-.6-.6-1.57-.6-2.17,0l-.03.03s0,0,0,0c-.59.59-.61,1.52-.08,2.14l-5.79-5.79c-.73-.73-1.92-.73-2.65,0-.73.73-.73,1.92,0,2.65l6.04,6.04-.42.4-6.04-6.04c-.73-.73-1.92-.73-2.65,0s-.73,1.92,0,2.65l8.73,8.73-3.38.55c-.76.12-1.38.69-1.57,1.44-.26,1.04.36,2.09,1.4,2.36l7.12,1.81c2.5.67,5.16.12,7.19-1.48.23-.18,1.26-1.2,1.47-1.4,3.15-3.14,3.15-8.24,0-11.39Z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "16.78 16.07 15.81 15.17 19.89 10.68 23.97 15.17 23 16.07 20.55 13.35 20.55 19.39 19.23 19.39 19.23 13.35 16.78 16.07"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "23 31.9 23.97 32.8 19.89 37.29 15.81 32.8 16.78 31.9 19.23 34.62 19.23 28.58 20.55 28.58 20.55 34.61 23 31.9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIconsTouchpadUpDown);
export default __webpack_public_path__ + "static/media/help_icons_touchpad_up_down.8540944e8c2476d6a71b464a45d17776.svg";
export { ForwardRef as ReactComponent };